/* globals Stripe */
/* eslint react/prefer-es6-class: "off"*/

import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import { createSubscription, refreshLogin } from '../actions/actions';
import './StripeCheckout.css';

const ReactScriptLoaderMixin = require('react-script-loader').ReactScriptLoaderMixin;

const StripeCheckout = React.createClass({
  mixins: [ReactScriptLoaderMixin],

  getInitialState() {
    return {
      stripeLoading: true,
      stripeLoadingError: false,
      submitDisabled: false,
      paymentError: null,
      paymentComplete: false,
      token: null,
    };
  },

  getScriptURL() {
    return 'https://js.stripe.com/v2/';
  },

  onScriptLoaded() {
    if (!StripeCheckout.getStripeToken) {
      // Put your publishable key here
      Stripe.setPublishableKey('pk_test_wm8nSTPbnGLFUcl2BkZ5bkcS');

      this.setState({ stripeLoading: false, stripeLoadingError: false });
    }
  },

  onScriptError() {
    this.setState({ stripeLoading: false, stripeLoadingError: true });
  },

  onSubmit(event) {
    const self = this;
    event.preventDefault();
    this.setState({ submitDisabled: true, paymentError: null });
    // send form here
    Stripe.createToken(event.target, (status, response) => {
      if (response.error) {
        self.setState({ paymentError: response.error.message, submitDisabled: false });
      } else {
        self.setState({ paymentComplete: true, submitDisabled: false, token: response.id });
        this.props.dispatch(createSubscription(
          {
            token: response.id,
            jwt: this.props.singleregistration.jwt,
          }
        ));
      }
    });
  },

  render() {
    const subscribe = this.props.subscribe;
    let info = '';

    if (!this.props.singleregistration.isRegistered || !this.props.singleregistration.jwt === null) {
      return <div>Please create an account first.</div>;
    } else if (this.state.stripeLoading || subscribe.isFetching) {
      return <CircularProgress />;
    } else if (this.state.stripeLoadingError) {
      return <div>Error loading payment form</div>;
    } else if (this.state.paymentComplete && subscribe.didSucceed) {
      return <div><strong>Payment complete</strong>! You should be redirected automatically.</div>;
    } else if (this.state.paymentComplete && subscribe.triedToSubscribe && !subscribe.didSucceed) {
      info = <div>Server error! Your payment did not go through. Please try again.</div>
    }

    let submitLabel = 'Subscribe to Pronounce Live for ';
    submitLabel += (this.props.activePlan === 'pronounce-six-months') ? '6 months, 4€' : 'one year, 8€';

    return (<form className="subscription-form" onSubmit={this.onSubmit} >
      <span className="subscription-form--error">{ info }</span><br />
      <span className="subscription-form--error">{ this.state.paymentError }</span><br />
      <input className="subscription-form--input" type="number" data-stripe="number" placeholder="Credit Card Number" /><br />
      <input className="subscription-form--input" type="number" data-stripe="exp-month" placeholder="Expiration Month" /><br />
      <input className="subscription-form--input" type="number" data-stripe="exp-year" placeholder="Expiration Year" /><br />
      <input className="subscription-form--input" type="number" data-stripe="cvc" placeholder="CVC (back of the card)" /><br />
      <br />
      <RaisedButton
        disabled={this.state.submitDisabled}
        onTouchTap={this.validateForm}
        label={submitLabel}
        primary
        type="submit"
      />

    </form>);
  },
});

export default StripeCheckout;



// WEBPACK FOOTER //
// ./src/components/StripeCheckout.js